import React, { useEffect } from "react";
// Rate Schedule Form

// Default
import { useState } from "react";
import { useNavigate } from "react-router-dom";

// Custom
import Layout from "../../layout";
import ContainedButton from "../../forms/button/ContainedButton";
import CustomDataTable from "../table/CustomTable";

// Mui
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { Chip } from "@mui/material";
import { TariffResponseT } from "../../types";

// Types

const columns = [
  "Tariff Name",
  "Effective Date",
  "Customer Category",
  "Commodity Type",
  "Status",
];

const getChipColor = (status: string) => {
  if (status === "active") return "#34C75990";
  if (status === "draft") return "#dadb8f";
  if (status === "inactive") return "#7D808F40";
};

const TariffsDashboard: React.FC = () => {
  const [taffisData, setTaffisData] = useState<TariffResponseT[]>([]);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const fetchTaffisData = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        "https://backend.voltreum.com/billing/tariffs"
      );
      const data = (await response.json()) as {
        tariffs: TariffResponseT[];
      };
      console.log(data);
      setTaffisData(data.tariffs);
    } catch (error) {
      console.error("Error fetching tariffs data:", error);
      setTaffisData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTaffisData();
  }, []);

  const rowsContent = taffisData?.map(
    (item: TariffResponseT, index: number) => (
      <TableRow
        key={index}
        sx={{
          cursor: "pointer",
        }}
        onClick={() =>
          navigate(`/tariff-form`, {
            state: { tariffData: item },
          })
        }
      >
        <TableCell>
          <Typography variant="tableBody">{item.scheduleName}</Typography>
        </TableCell>
        <TableCell>
          <Typography variant="tableBody">
            {item.scheduleData.effectiveDate}
          </Typography>
        </TableCell>

        <TableCell>
          <Typography variant="tableBody">
            {item.scheduleData.customerCategory}
          </Typography>
        </TableCell>

        <TableCell>
          <Typography variant="tableBody">
            {item.scheduleData.commodityType}
          </Typography>
        </TableCell>
        <TableCell>
          <Chip
            label={item.status.charAt(0).toUpperCase() + item.status.slice(1)}
            sx={{
              color: item.status == "active" ? "black" : "black",
              backgroundColor: getChipColor(item.status),
              p: 0,
              m: 0,
              height: "22px",
              fontSize: "12px",
            }}
          />
        </TableCell>
      </TableRow>
    )
  );

  return (
    <Layout>
      <Card>
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
          mr={"10px"}
        >
          <CardHeader title={<Typography variant="h5">Tariffs</Typography>} />
          <Stack direction={"row"} gap={2}>
            <ContainedButton
              label={"Create New Tariff"}
              sx={{
                width: "fit-content",
                fontWeight: 600,
                color: "#ffffff",
              }}
              onClick={() => navigate("/tariff-form")}
            />
            <ContainedButton
              label={"Refresh"}
              onClick={() => fetchTaffisData()}
            />
          </Stack>
        </Stack>
        <Divider />

        <CardContent>
          <CustomDataTable
            rowsContent={rowsContent}
            columns={columns}
            isLoading={loading}
          />
        </CardContent>
      </Card>
    </Layout>
  );
};

export default TariffsDashboard;
